module.exports = __webpack_public_path__ + "img/google play.7e4cbfd7.png";